import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Tooltip, Tag, Spin, message } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import gestionXml from '../../Actions/gestionXml';
import TableView from '../tableView';
import Download from '../download';
import { getStatusColor, getTaxPayer, renderStatusCell } from '../../helpers';
import { Link } from 'react-router-dom';
import moment from 'moment';
import TaxPayerVolume from '../TaxPayerVolume';
import CustomSelect from '../_Generic/Select/CustomSelect';
import CustomRangePicker from '../_Generic/RangePicker';
import { sortByDate, sortByString, sortStringByKey, parseDateFormat } from '../../Helpers/TableSorter';
import { getFilterByColumnValue } from '../../Helpers/PortalHelpers';
import { CATEGORY_GA, eventGA } from '../../Helpers/GoogleAnalytics';
import user from '../../Actions/user';
import RoleHelper from "../../Helpers/RoleHelper";
const { getUserData, getRoleData } = user.actions;
const { setDataDownloadFiles, getZipFromPath, getEfosRequestData, updateEfosDataForm, restartEfosState, createEfosRequest, getLastEfos } = gestionXml.actions;

const documentItems = [
	{ key: 'Emision', value: 'Emision', label: 'Emisión', disabled: false },
	{ key: 'Recepcion', value: 'Recepcion', label: 'Recepción', disabled: false }
];

class DownloadXmlTab extends Component {
	constructor(props) {
		super(props);
		this.generateRequestEfos = this.generateRequestEfos.bind(this);
		this.actions = this.actions.bind(this);
		this.getZipFromPath = this.getZipFromPath.bind(this);
		this.validateWebServiceRequest = this.validateWebServiceRequest.bind(this);
		this.getRfcItems = this.getRfcItems.bind(this);
		this.handleChangeDocuments = this.handleChangeDocuments.bind(this);
		this.changeDatesRange = this.changeDatesRange.bind(this)
	}

	componentDidMount() {
		eventGA(CATEGORY_GA.management.efosValidation);
		let query = {
			...this.props.pagination,
			page: 1,
			perPage: 5
		}
		this.props.restartEfosState();
		this.props.getEfosRequestData(query);
		this.props.getLastEfos();
		this.interval = setInterval(() => this.props.getEfosRequestData(query), 60000);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
		this.props.restartEfosState();
	}

	render() {
		const { downloadXmls, isUserLoading, tableLoading, isLoading, userData, efosState, isFreePlan, roleHelper } = this.props;
		const { documents, taxId, } = downloadXmls;
		const items = this.getRfcItems(userData);
		const { form: efosForm, data, lastRequest } = efosState;
		const { DocumentType, StartDate, EndDate } = efosForm;
		const lastRequestLabel = this.getLastEfosRequest(lastRequest);
		return (
			<Fragment>
				<div className="download-xmls-container">
					<div className="download-xmls-container-text">
						Esta opción de descarga es exclusivamente para obtener el reporte de EFOS y Cancelados, es más rápida que las dos anteriores. Selecciona los parámetros de descarga y los reportes de que deseas obtener.
					</div>
				</div>
				<div className="filters-container">
					<div className="input-container">
						<label htmlFor="" className="label block">RFC de descarga:</label>
						<CustomSelect
							showSearch
							allowClear
							onClear={this.handleClearTaxId.bind(this)}
							onSearch={this.handleSearchTaxId.bind(this)}
							loading={this.props.taxIdSearchLoading}
							defaultValue={taxId}
							value={taxId}
							style={{ width: '230px' }}
							onChange={this.handleChangeTaxId.bind(this)}
							items={items}
						/>
					</div>
					<div className="input-container">
						<label htmlFor="" className="label block"> Documentos:</label>
						<CustomSelect
							value={DocumentType}
							style={{ width: '230px' }}
							onChange={this.handleChangeDocuments}
							items={this.selectdocumentType(roleHelper)}
						/>
					</div>
					<div className="input-container">
						<label htmlFor="" className="label block">Seleccionar Rango de fecha:</label>
						<CustomRangePicker
							startDate={StartDate}
							endDate={EndDate}
							style={{ width: '460px' }}
							onChange={this.changeDatesRange}
							disabledDate={this.disabledDate}
						/>
					</div>
				</div>
				<div className="extras-container">
					<TaxPayerVolume taxId={taxId} documents={documents} />
					<div className="actions-container">
						<Button type="primary" onClick={this.generateRequestEfos} disabled={tableLoading || isFreePlan}>Solicitar Descarga</Button>
					</div>
				</div>
				<div className="line"></div>
				<div className="table-title-with-message">
					<h1 className="regular-text table-title">Solicitudes con EFOS</h1>
					<span className="table-message"><b>Última solicitud:</b> {lastRequestLabel}</span>
				</div>

				<TableView
					loading={tableLoading}
					defaultPageSize={10}
					columns={this.actions()}
					data={data}
					disablePagination
				/>
				<div className="align-button-right">
					<Link to='./status'>
						<Button>Ver todas</Button>
					</Link>
				</div>
				{((!tableLoading && !this.props.taxIdSearchLoading) && isLoading) &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
					</div>
				}
			</Fragment>
		);
	}

	getRfcItems(items) {
		return items.map(element => ({ value: element.taxId, label: element.taxId, key:element.taxId }));
	}

	getZipFromPath(filePath, event) {
		if (filePath)
			this.props.getZipFromPath(filePath);
		event.stopPropagation();
	}

	handleChangeDocuments(value) {
		this.props.updateEfosDataForm({ DocumentType: value });
	}

	handleChangeTaxId(value) {
		this.props.setDataDownloadFiles({ taxId: value });
	}

	handleSearchTaxId(value) {
		this.populateTaxIdData(value);
	}

	handleClearTaxId() {
		this.populateTaxIdData('');
	}

	populateTaxIdData(value) {
		this.props.getUserData({
			...this.props.certificatesPagination,
			page: 1,
			perPage: 200,
			filter: value,
			isFiltered: true
		});
	}

	generateRequestEfos() {
		if (this.validateWebServiceRequest()) {
			this.props.createEfosRequest(this.props.efosState.form);
		} else {
			message.warning('El volumen de facturas de Emisión supera el máximo de descarga por Web Service, intenta con otros parámetros', 5);
		}
	}

	validateWebServiceRequest() {
		const { downloadXmls, taxpayerVolume } = this.props;
		const { documents, taxId, startDate, endDate } = downloadXmls;
		const MAX_DOCUMENTS_WEB_SERVICE = 200000
		let taxIdFound = getTaxPayer(taxpayerVolume, taxId);
		let differenceBetweenDays = moment(endDate).diff(startDate, 'days');

		if (taxIdFound) {
			if (differenceBetweenDays >= 30) {
				if (documents.toLowerCase() === 'emision') {
					if (taxIdFound.issuingVolumeMonthly >= MAX_DOCUMENTS_WEB_SERVICE)
						return false;
				} else {
					if (taxIdFound.receivingVolumeMonthly >= MAX_DOCUMENTS_WEB_SERVICE)
						return false;
				}
			} else {
				if (documents.toLowerCase() === 'emision') {
					if (taxIdFound.issuingVolumeDaily * differenceBetweenDays >= MAX_DOCUMENTS_WEB_SERVICE)
						return false;
				} else {
					if (taxIdFound.receivingVolumenDaily * differenceBetweenDays >= MAX_DOCUMENTS_WEB_SERVICE)
						return false;
				}
			}
		}

		return true;
	}

	changeDatesRange(dates, dateStrings) {
		this.props.updateEfosDataForm({ StartDate: dateStrings[0], EndDate: dateStrings[1] });
	}

	disabledDate = (current) => {
		if (!current) return false;
		const today = moment().endOf('day');
		const fiveYearsAgo = moment().subtract(5, 'years').startOf('day');
		return current > today || current < fiveYearsAgo;
	}

	getLastEfosRequest(data) {
		let lastRequest = 'No disponible';
		if (data) {
			lastRequest = parseDateFormat(data.createdDate, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss');
		}
		return lastRequest;
	}

	selectdocumentType = (roleHelper) => {
		return [
				{key: 'Emision', value: 'Emision', label: 'Emisión', disabled: !roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOAD,RoleHelper.DOCUMENT_TYPE_EMITIDOS)},
				{key: 'Recepcion', value: 'Recepcion', label: 'Recepción', disabled: !roleHelper.hasAllOptions(RoleHelper.ACTION_DOWNLOAD,RoleHelper.DOCUMENT_TYPE_RECIBIDOS)}
		]
	}

	actions() {
		let columns = [
			{
				title: 'Registro',
				dataIndex: 'createdDate',
				key: 'createdDate',
				sorter: (a, b) => sortByDate(a, b, 'createdDate'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'RFC',
				dataIndex: 'taxId',
				key: 'taxId',
				sorter: (a, b) => sortStringByKey(a, b, 'taxId'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Rango de fechas',
				key: 'date',
				render: (tex, row) => (
					<span>{row.dateFrom} - {row.dateTo}</span>
				),
				sorter: (a, b) => sortByDate(a, b, 'dateFrom'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Tipo de descarga',
				dataIndex: 'requestType',
				key: 'requestType',
				sorter: (a, b) => sortStringByKey(a, b, 'requestType'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Tipo de documentos',
				dataIndex: 'document',
				render: (tex, row) => (
					<span>{row.documentType}</span>
				),
				sorter: (a, b) => sortStringByKey(a, b, 'documentType'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Filtro',
				dataIndex: 'filterBy',
				render: (text, row) => {
					return <span>{getFilterByColumnValue(row)}</span>;
				},
				sorter: (a, b) => {
					const one = getFilterByColumnValue(a);
					const two = getFilterByColumnValue(b);
					return sortByString(one, two);
				},
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Estatus',
				dataIndex: 'statusRequest',
				key: 'statusRequest',
				render: (text, row) => renderStatusCell(row.statusRequest, row.totalFiles),
				sorter: (a, b) => {
					return sortByString(a.statusRequest[0], b.statusRequest[0]);
				},
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Relación con EFOS',
				dataIndex: 'efosIndicator',
				key: 'efosIndicator',
				render: efosIndicator => {
					if (efosIndicator === 1) {
						return (
							<Tooltip title='Encontramos xml relacionados con EFOS en esta solicitud'>
								<WarningOutlined
									style={{ fontSize: '20px', color: '#ffc70d' }}
								/>
							</Tooltip>
						);
					}
					return '-'
				},
				sorter: (a, b) => {
					return sortStringByKey(a, b, 'efosIndicator');
				},
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: '',
				key: 'action',
				render: (text, row) => (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						{
							row.processes.map((report, index) => {
								return (
									<Download download={this.getZipFromPath} key={index} pos={index} report={report} />
								)
							})
						}

					</div>
				)
			}
		];
		return columns;
	}
}

const mapStateToProps = state => {
	let tableLoader = state._genericComponents.loading.find('efosTable');
	let userDataLoader = state._genericComponents.loading.find('userLoading');
	let TaxIdSearchLoader = state._genericComponents.loading.find('taxIdSearchLoading');
	const roleHelper = new RoleHelper(state.user.role);

	return {
		downloadXmls: state.gestionXml.downloadXmls,
		userData: state.user.userData,
		tableLoading: tableLoader ? tableLoader.isLoading : false,
		isLoading: state._genericComponents.loading.isCurrentlyLoading,
		isUserLoading: userDataLoader ? userDataLoader.isLoading : false,
		taxIdSearchLoading: TaxIdSearchLoader ? TaxIdSearchLoader.isLoading : false,
		taxpayerVolume: state.taxpayer.taxpayerVolume,
		efosState: state.gestionXml.efos,
		pagination: state.gestionXml.efos.paginatation,
		isFreePlan: state.license.isFreePlan,
		roleHelper
	};

};

const mapDispatchToProps = dispatch => {
	return {
		setDataDownloadFiles(data) {
			dispatch(setDataDownloadFiles(data));
		},
		getZipFromPath(filePath) {
			dispatch(getZipFromPath(filePath))
		},
		getEfosRequestData(data) {
			dispatch(getEfosRequestData(data));
		},
		updateEfosDataForm(data) {
			dispatch(updateEfosDataForm(data));
		},
		restartEfosState() {
			dispatch(restartEfosState());
		},
		createEfosRequest(data) {
			dispatch(createEfosRequest(data));
		},
		getLastEfos(data) {
			dispatch(getLastEfos(data));
		},
		getUserData(query) {
			dispatch(getUserData(query));
		},
		getRoleData() {
			dispatch(getRoleData());
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadXmlTab);